// Helper per aprire/visualizzare allegati con autenticazione.
// Motivo: `<img src>` e `<a href target=_blank>` non garantiscono l'invio del
// cookie httpOnly (in particolare dopo scadenza access_token, senza refresh via
// axios). Scarichiamo il file autenticati e apriamo un ObjectURL.
import { useEffect, useState } from "react";
import api from "./api";

const _cache = new Map(); // id -> objectURL (per img)

export async function fetchAllegatoBlobUrl(id) {
  if (_cache.has(id)) return _cache.get(id);
  const res = await api.get(`/allegati/${id}/file`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  _cache.set(id, url);
  return url;
}

export function revokeAllegatoBlobUrl(id) {
  const url = _cache.get(id);
  if (url) {
    URL.revokeObjectURL(url);
    _cache.delete(id);
  }
}

// Apri allegato in nuova scheda (o forza download se filename fornito).
// Usa fetch autenticato → blob → objectURL → window.open.
export async function openAllegato(id, filename) {
  try {
    const res = await api.get(`/allegati/${id}/file`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    // Preferiamo target _blank: PDF/immagini si aprono inline; altri tipi
    // vengono scaricati dal browser secondo policy.
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w && filename) {
      // popup bloccato → fallback download esplicito
      const a = document.createElement("a");
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();
    }
    // Rilascia l'objectURL dopo un po' per lasciare tempo al tab di caricarlo
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    console.error("openAllegato error", e);
    throw e;
  }
}

// Componente <AllegatoImg /> — carica un'immagine autenticata come blob.
export function AllegatoImg({ id, alt, className, loading = "lazy", ...rest }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let cancelled = false;
    let localUrl = null;
    (async () => {
      try {
        const res = await api.get(`/allegati/${id}/file`, { responseType: "blob" });
        localUrl = URL.createObjectURL(res.data);
        if (!cancelled) setSrc(localUrl);
      } catch (e) {
        console.error("AllegatoImg fetch error", id, e);
      }
    })();
    return () => {
      cancelled = true;
      if (localUrl) URL.revokeObjectURL(localUrl);
    };
  }, [id]);
  if (!src) {
    return <div className={`bg-slate-100 dark:bg-slate-800 animate-pulse ${className || ""}`} aria-label={alt} />;
  }
  return <img src={src} alt={alt} className={className} loading={loading} {...rest} />;
}
